import styled, { keyframes } from 'styled-components';
import { pallette } from '../../config/pallette';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: calc(100svh - 82px); /* 82px - top banner height */

  @media (max-width: 430px) {
    position: relative;
  }
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${pallette.white};
  width: 100%;

  @media (max-width: 820px) {
    justify-content: center;
  }
`;

export const AllMessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  overflow: auto;
  width: 100%;
  margin-top: 15px;

  @media (max-width: 820px) {
    min-width: auto;
    width: calc(100svw - 30px);
  }
`;

export const AllMessagesContent = styled.div`
  width: 100%;
  max-width: 800px; /* Restrict content width */
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MessageContainerUser = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const MessageContainerBot = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

export const MessageBotImage = styled.img`
  width: 35px;
  height: 35px;
`;

export const MessageUser = styled.span`
  font-size: 16px;
  text-align: right;
  background-color: ${pallette.lightGray};
  color: ${pallette.text};
  padding: 10px;
  margin: 5px 0;
  border-radius: 10px;
  align-self: right;
  overflow: hidden;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const MessageBot = styled.div`
  font-size: 16px;
  color: ${pallette.text};
  text-align: left;
  background-color: transparent;
  padding: 10px;
  border-radius: 10px;
  white-space: pre-line;
  overflow-wrap: break-word;
  overflow: hidden;
  margin-top: 5px;
  width: calc(100% - 60px);

  @media (max-width: 480px) {
    font-size: 16px;
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1em 0;
  }

  th,
  td {
    border: 1px solid ${pallette.gray};
    padding: 0.6em;
    text-align: left;
    vertical-align: top;
  }

  thead {
    background-color: ${pallette.lightGray};
    font-weight: bold;
  }

  pre code {
    background: ${pallette.lightGray};
    padding: 10px;
    display: block;
    overflow-x: auto;
    border-radius: 5px;
    font-family: monospace;
  }

  code {
    background: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px;
  }
`;

export const MessageBotLoading = styled.span`
  font-size: 16px;
  color: ${pallette.text};
  text-align: left;
  background-color: transparent;
  padding: 10px;
  border-radius: 10px;
  white-space: pre-line;
  overflow-wrap: break-word;
  overflow: hidden;
  margin-top: 5px;
  width: calc(100% - 60px);
  position: relative;

  &::after {
    content: '...';
    display: inline-block;
    width: 1.5em;
    text-align: left;
    animation: dots 1.5s steps(3, end) infinite;
  }

  @keyframes dots {
    0% { content: ''; }
    33% { content: '.'; }
    66% { content: '..'; }
    100% { content: '...'; }
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const MessageError = styled.span`
  font-size: 16px;
  color: ${pallette.text};
  text-align: left;
  padding: 10px;
  border-radius: 10px;
  white-space: pre-line;
  overflow-wrap: break-word;
  overflow: hidden;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ isStartingConversation }) =>
    isStartingConversation ? pallette.lightGray : pallette.white};
  border-radius: 16px;
  width: 60vw;
  border: 2px solid ${pallette.lightGray};
  margin: auto auto;

  @media (max-width: 430px) {
    width: 90vw;
  }
`;

export const Input = styled.textarea`
  border: none;
  border-radius: 16px;
  font-size: 16px;
  flex: 1;
  padding: 15px;
  background-color: ${({ isStartingConversation }) =>
    isStartingConversation ? pallette.lightGray : pallette.white};
  color: ${pallette.text};
  font-family: 'ProximaNova';
  resize: none;
  min-height: ${({ isStartingConversation }) =>
    isStartingConversation ? '45px' : '80px'};
  padding: ${({ isStartingConversation }) =>
    isStartingConversation ? '25px 15px 0 15px' : 'auto'};
  max-height: 150px;
  overflow-y: auto;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${pallette.text};
  }
`;

export const SendContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const InputTextLengthIndicator = styled.span`
  font-weight: normal;
  color: ${pallette.gray};
  margin-right: 5px;
`;

export const SendButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  cursor: pointer;
`;

export const RetryButton = styled.span`
  color: ${pallette.main};
  font-weight: bold;
  cursor: pointer;
`;

export const TopicButton = styled.div`
  background-color: ${pallette.lightGray};
  cursor: pointer;
  padding: 5px;
  margin: 5px;
`;

export const ChatbotTitle = styled.h2`
  display: flex;
  font-size: 20px;

  @media (max-width: 430px) {
    margin-left: 20px;
  }
`;

export const ClearChatButton = styled.button`
  display: flex;
  background-color: transparent;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border: none;
  font-weight: bold;
  align-self: flex-end;
  margin: 10px 0;

  @media (max-width: 430px) {
    margin: 10px 15px;
  }
`;

export const ClearChatButtonText = styled.span`
  font-size: 12px;
  border-bottom: 1px solid ${pallette.text};
  color: ${pallette.text};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 430px) {
    backgruond-color: red;
    width: 100vw;
    padding: 5px;
  }

  // Surface Duo is a weird device
  @media (max-width: 540px) {
    margin: 0 20px;
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border: 2px solid ${pallette.main};
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin: 25x 0;
`;

export const SpinnerBotReplying = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid ${pallette.main};
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin-left: 50px;
  margin-top: 10px;
`;

export const CaveatTextContainer = styled.div`
  padding: 5px 0px;
  alignSelf: center;

  @media (max-width: 540px) {
    margin: 0 20px;
    display: flex;
  }
`;

export const CaveatText = styled.span`
  color: ${pallette.caveatGrey};
  font-size: 12px;
  text-align: center;
`;

export const CaveatTextLink = styled.a`
  color: ${pallette.main};
  cursor: pointer;
`;
